export class GeoPosition {

	constructor(lat, lng) {
		this.lat = lat;
		this.lng = lng;
	}

	// get lat() { return this.lat; }
	// set lat(value) { this.lat = value; }

	// get lng() { return this.lng; }
	// set lng(value) { this.lng = value; }
}

export class Marker {

	// get position() { return this._position; }
	// set position(value) { this._position = value; }

	// get title() { return this._title; }
	// set title(value) { this._title = value; }

	// get icon() { return this._icon; }
	// set icon(value) { this._icon = value; }

	// get info() { return this._info; }
	// set info(value) { this._info = value; }
	
	constructor() {
		this.position = new GeoPosition(0, 0);
	}
}

export class Polyline {

	// get position() { return this._position; }
	// set position(value) { this._position = value; }

	// get title() { return this._title; }
	// set title(value) { this._title = value; }

	// get geodesic() { return this._geodesic; }
	// set geodesic(value) { this._geodesic = value; }

	// get strokeColor() { return this._strokeColor; }
	// set strokeColor(value) { this._strokeColor = value; }

	// get strokeOpacity() { return this._strokeOpacity; }
	// set strokeOpacity(value) { this._strokeOpacity = value; }

	// get strokeWeight() { return this._strokeWeight; }
	// set strokeWeight(value) { this._strokeWeight = value; }

	constructor() {
		this.geodesic = true;
		this.strokeColor = "#FF000";
		this.strokeOpacity = 1.0;
		this.strokeWeight = 2;
	}
}